import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=36a3ba1b&"
import script from "./SmallCard.vue?vue&type=script&lang=js&"
export * from "./SmallCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a3ba1b')) {
      api.createRecord('36a3ba1b', component.options)
    } else {
      api.reload('36a3ba1b', component.options)
    }
    module.hot.accept("./SmallCard.vue?vue&type=template&id=36a3ba1b&", function () {
      api.rerender('36a3ba1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SmallCard.vue"
export default component.exports